import { IApplicationState } from '../../types/redux';

export const selectSeoH1 = (state: IApplicationState) => {
  return state.seo.pageData?.h1;
};
